/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPriceTypeDto
 */
export interface GetPriceTypeDto {
    /**
     * 
     * @type {string}
     * @memberof GetPriceTypeDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetPriceTypeDto
     */
    consultationType?: GetPriceTypeDtoConsultationTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceTypeDto
     */
    articleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceTypeDto
     */
    supportingExaminationDictId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceTypeDto
     */
    pricingGroupId?: string | null;
}


/**
 * @export
 */
export const GetPriceTypeDtoConsultationTypeEnum = {
    Neurological: 'Neurological',
    Ophthalmologist: 'Ophthalmologist',
    ENT: 'ENT',
    Psychiatric: 'Psychiatric'
} as const;
export type GetPriceTypeDtoConsultationTypeEnum = typeof GetPriceTypeDtoConsultationTypeEnum[keyof typeof GetPriceTypeDtoConsultationTypeEnum];


/**
 * Check if a given object implements the GetPriceTypeDto interface.
 */
export function instanceOfGetPriceTypeDto(value: object): value is GetPriceTypeDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetPriceTypeDtoFromJSON(json: any): GetPriceTypeDto {
    return GetPriceTypeDtoFromJSONTyped(json, false);
}

export function GetPriceTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPriceTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'consultationType': json['consultationType'] == null ? undefined : json['consultationType'],
        'articleId': json['articleId'] == null ? undefined : json['articleId'],
        'supportingExaminationDictId': json['supportingExaminationDictId'] == null ? undefined : json['supportingExaminationDictId'],
        'pricingGroupId': json['pricingGroupId'] == null ? undefined : json['pricingGroupId'],
    };
}

export function GetPriceTypeDtoToJSON(value?: GetPriceTypeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'consultationType': value['consultationType'],
        'articleId': value['articleId'],
        'supportingExaminationDictId': value['supportingExaminationDictId'],
        'pricingGroupId': value['pricingGroupId'],
    };
}

